import { Component, OnInit } from '@angular/core';
import {CalendarService} from '../../../services/calendar.service';
import{ApiService} from '../../../services/api.service';
import { formatDate } from "@angular/common";
@Component({
  selector: 'app-presensi',
  templateUrl: './presensi.page.html',
  styleUrls: ['./presensi.page.scss'],
})
export class PresensiPage implements OnInit {

  constructor(private calendar:CalendarService, private api:ApiService) { }
  cal:any={};
  week:any=[];
  selected:any;
  selectedPresensi:any={};
  ngOnInit() {
  	this.getCal();
    this.getUserData();
    this.getMapel();
  }

  userData:any={};
  getUserData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
      this.userData=data;
      this.getDataPresensi();
    })
  }

  dataMapel:any=[];
  getMapel()
  {
      this.api.data('mapel/all','get','').subscribe(data=>{
          this.dataMapel=data;
      })
  }

  getCal()
  {
    this.cal={};
  	var cal=this.calendar.today().data;
    this.selected=this.calendar.today().selected;
  	this.parseCal(cal);    
  }
  parseCal(cal)
  {
    var res={};
    for(var i=0; i<cal.length;i++)
    {
      var key=Math.floor(i/7);
      if(res[key]==undefined)
      {
        res[key]=[cal[i]];
      }else{
        res[key].push(cal[i]);
      }
    }
    this.cal=res;
    this.week=Object.keys(res);
  }
  next()
  {
      console.log(this.selected);
      var cal=this.calendar.next(this.selected).data;
      this.selected=this.calendar.next(this.selected).selected;
      this.parseCal(cal);
  }
  prev()
  {
      console.log(this.selected);
      var cal=this.calendar.previous(this.selected).data;
      this.selected=this.calendar.previous(this.selected).selected;
      this.parseCal(cal);
  }
  //pilih cell
  cellSelected:any={};  
  selectCell(m,n)
  {
     this.cellSelected={};
     this.selectedPresensi={};
     this.cellSelected[m+n]=true;
     var date=this.cal[m][n];
     this.selected=new Date(date.tahun,date.bulan-1,date.tanggal);
     var formatedDate=formatDate(this.selected, 'yyyy-MM-dd', 'en-US');     
     if(this.dataPresensi[formatedDate]!=undefined)
     this.selectedPresensi=this.dataPresensi[formatedDate];
  }

  //data presensi
  dataPresensi:any={};
  getDataPresensi()
  {
      this.api.data('presensi/'+this.userData.id,'get','').subscribe(data=>{
          this.parsePresensi(data);
          //console.log(data);
      })
  }
  parsePresensi(data)
  {
      for(var i=0; i<data.length; i++)
      {          
          this.parseStatus(data[i],'sakit');
          this.parseStatus(data[i],'izin');
          this.parseStatus(data[i],'alpa');
      }
      var formatedDate=formatDate(this.selected, 'yyyy-MM-dd', 'en-US');
      if(this.dataPresensi[formatedDate]!=undefined)
      this.selectedPresensi=this.dataPresensi[formatedDate];

      console.log(this.selectedPresensi);
  }
  parseStatus(data,status)
  {
      var stat=Object.keys(data[status]);   
      if(stat.length>0)
      {
          for(var i=0; i<stat.length; i++)
          {
              if(this.dataPresensi[stat[i]]==undefined)
              this.dataPresensi[stat[i]]={};              
              this.dataPresensi[stat[i]][status]=data[status][stat[i]];   
          }
      }
  }

  getMarker(tgl,status)
  {
      var dt=new Date(tgl.tahun,tgl.bulan-1,tgl.tanggal);
      var res=formatDate(dt, 'yyyy-MM-dd', 'en-US');
      
      if(this.dataPresensi[res]!=undefined && this.dataPresensi[res][status])
      {
          return true;
      }
      //return res;
  }
  detailMapel(kode)
  {
      var idx=this.dataMapel.map(function(e){return e.kode}).indexOf(kode);
      if(idx!=-1)
      return this.dataMapel[idx].nama;
  }

}
